import {AnyEvent, JOB_SECTION_ITEM_UPDATED, JobSectionItemUpdatedEvent} from '../type';

export default function jobSectionItemUpdated(payload: JobSectionItemUpdatedEvent['payload']): AnyEvent {
  return {
    type: JOB_SECTION_ITEM_UPDATED,
    payload,
  }
}